import React from 'react'
import SubAdmin from './SubAdmin'

const SubAdminLayout = () => {
  return (
    <div className="container">
      <SubAdmin />
    </div>
  )
}

export default SubAdminLayout
